module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.76d23a9.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Roboto/Roboto-Medium.ttf
// module id = 170
// module chunks = 245 246